import styled from '@emotion/styled';

export const FormContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  maxWidth: theme.breakpoints.values.md,
}));
